import { connect } from 'react-redux';

import { Entities, fetchByCompanyId, getEntities, patch, save } from 'src/common';
import { getOwnCompany } from 'src/selectors/bus-companies';
import CalendarSeasonCalculationCalendarAdministration from 'src/components/administration/calendar-season-calendar/calendar-season-calculation-calendar-administration';

const mapStateToProps = state => {
    return {
        selectedCompany: state.selectedCompany,
        company: getOwnCompany(state),
        calendarSeason: getEntities(state, Entities.CALENDAR_SEASON, state.selectedCompany),
        calculations: getEntities(state, Entities.CALCULATION, state.selectedCompany),
    };
};

const CalendarSeasonCalculationCalendarAdministrationContainer = connect(mapStateToProps, {
    patch,
    fetchByCompanyId,
    save,
})(CalendarSeasonCalculationCalendarAdministration);

export default CalendarSeasonCalculationCalendarAdministrationContainer;
